<!-- frontend/src/components/FileDownload.vue -->
<template>
  <div v-if="!internal">
    <h1>Download File</h1>


    <div class="download-form">
      <h2>Download Shared File</h2>
      <input type="text" v-model="uuid" placeholder="UUID">
      <input type="password" v-model="password" placeholder="Password">
      <button class="btn" @click="downloadFile">Download</button>
      <div v-if="progress > 0">
        <p>Progress: {{ progress }}%</p>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="download-form">
      <h2>Download Shared File</h2>
      <button class="download-button" @click="downloadFile">Download</button>
      <div v-if="progress > 0">
        <p>Progress: {{ progress }}%</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import NProgress from 'nprogress';
import {saveAs} from 'file-saver'
import process from 'process';

import 'nprogress/nprogress.css';

export default {
  props: {
    internal: {
      type: Boolean,
      required: false,
      default: false
    },
    fileUuid: {
      type: String,
      required: false,
      default: ''
    },
  },
  data() {
    return {
      uuid: '',
      password: '',
      progress: 0
    };
  },
  methods: {
    async downloadFile() {
      try {
        NProgress.start();
        NProgress.set(1);
        this.progress = 1;
        const password = this.password;
        const uuid = this.uuid;
        const _this = this;
        // Step 1: Get file size from server
        const headResponse = await axios.post(process?.env?.VUE_APP_API_URL + '/download', {
          uuid: this.uuid, password: this.password, onlyInfo: true
        });
        const fileSize = parseInt(headResponse.data.fileSize, 10);
        const fileName = headResponse.data.fileName;
        const chunkSize = 90 * 1024 * 1024; // 90 MB
        const totalChunks = Math.ceil(fileSize / chunkSize);

        let downloaded = 0;

        const stream = new ReadableStream({
          async start(controller) {
            for (let i = 0; i < totalChunks; i++) {
              const start = i * chunkSize;
              const end = Math.min(start + chunkSize, fileSize) - 1;

              const response = await axios.post(process?.env?.VUE_APP_API_URL + '/download', {
                uuid: uuid,
                password: password
              }, {
                responseType: 'arraybuffer',
                headers: {
                  'Range': `bytes=${start}-${end}`
                }
              });

              controller.enqueue(new Uint8Array(response.data));
              downloaded += response.data.byteLength;
              _this.progress = Math.round((downloaded * 100) / fileSize);
              NProgress.set(this.progress / 100);
            }
            controller.close();
          }
        });

        const blob = await new Response(stream).blob();

        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        console.log('Is mobile:', isMobile);
        if (isMobile) {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        } else {
          saveAs(blob, fileName);
        }

        NProgress.done();
      } catch (error) {
        console.error('Error downloading file:', error);
        NProgress.done();
      }
    }

  },
  mounted() {
    if (this.internal) {
      this.uuid = this.fileUuid;
    }
  }
}
</script>

<style>

.download-button {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.download-button:hover {
  background-color: #0056b3;
}
</style>

